import { formatFileUrl, FILE_DOMAIN } from '@/utils/domains'
let format = value => {
  return value >= 10 ? value : "0" + value;
};

let isRealNum = val => {
  // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，

  if (val === "" || val == null) {
    return false;
  }
  if (!isNaN(val)) {
    //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
    //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
    return true;
  } else {
    return false;
  }
};

/**
 * 时间格式化
 */
export const date = (time, type) => {
  let result;
  if (!time) {
    return (result = "");
  }
  if (isRealNum(time)) {
    time = time < 10000000000 ? time * 1000 : time;
  }
  let date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let second = date.getSeconds();
  switch (type) {
    case 0: // 01-05
      result = `${format(month)}-${format(day)}`;
      break;
    case 1: // 11:12
      result = `${format(hours)}:${format(minutes)}`;
      break;
    case 2: // 2015-01-05
      result = `${year}-${format(month)}-${format(day)}`;
      break;
    case 3: // 2015-01-05 11:12
      result = `${year}-${format(month)}-${format(day)}  ${format(
        hours
      )}:${format(minutes)}`;
      break;
    case 4: // 2015-01-05 11:12:06
      result = `${year}-${format(month)}-${format(day)}  ${format(
        hours
      )}:${format(minutes)}:${format(second)}`;
      break;
    case 5: // 11:12:30
      result = `${format(hours)}:${format(minutes)}:${format(second)}`;
      break;
  }
  return result;
};

/**
 * 如果时间格式是返回的是1970-01-01，就返回空
 */
export const dateRes = (time, type) => {
  let result = date(time, type);
  if (result == "1970-01-01  08:00:00" || result == "1970-01-01") {
    return "----";
  } else {
    return result;
  }
};
/**
 * 图片格式化
 */
export const imgUrl = (url, size) => {
  if (!url) return ''
  if (size) {
    url = url.replace('group1/', size + '/group1/')
  }
  if (/^https?:\/\//.test(url)) {
    return url.replace('http://mk.yonyou.com', FILE_DOMAIN).replace('https://mk.yonyou.com', FILE_DOMAIN)
  }
  return formatFileUrl(url)
};

/**
 * 文件格式化
 */
export const fileUrl = url => {
  return formatFileUrl(url)
};

export const boolToString = (param, code) => {
  if (param != undefined && param != null) {
    if (param === true) {
      return "是";
    } else if (param === false) {
      return "否";
    } else if (
      param.toString().length == 13 &&
      param.toString().indexOf("+") === -1 &&
      !isNaN(param) && param.toString().indexOf("00") != 0
    ) {
      return date(param, 4);
    } else {
      if (code === "msg_receiveStatus") {
        if (param == "DELIVRD" || param == "DELIVERED") {
          return "成功";
        } else {
          return "失败";
        }
      } else {
        return param;
      }
    }
  } else {
    return param;
  }
};

export const fieldStatus = (value) => {
  let tempstr = value;
  switch (value) {
    case 1:
      tempstr = "启用";
      break;
    case 0:
      tempstr = "停用";
      break;
  }
  return tempstr;
};

export const fieldType = (value) => {
  let tempstr = value;
  switch (value) {
    case "textbox":
      tempstr = "文本控件";
      break;
    case "richbox":
      tempstr = "富文本编辑器";
      break;
    case "image":
      tempstr = "图片";
      break;
    case "button":
        tempstr = "按钮";
      break;
    case "radio":
      tempstr = "单选";
      break;
    case "checkbox":
      tempstr = "多选";
      break;
    case "select":
      tempstr = "下拉框";
      break;
    case "table":
      tempstr = "组合控件";
      break;
    case "file":
      tempstr = "文件";
      break;
  }
  return tempstr;
};

/*
  b装换成M
*/
function toDecimal(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f;
}
export const BToMB = b => {
  if (b < 1048576) {
    return toDecimal(b / 1024) + "kb";
  } else {
    return toDecimal(b / 1024 / 1024) + "mb";
  }
};

/*
  根据类型返回汉字
*/
export const naireType = type => {
  let result = "";
  switch (type) {
    case "input":
      result = "单行输入框";
      break;
    case "textarea":
      result = "多行输入框";
      break;
    case "radio":
      result = "单选题";
      break;
    case "checkbox":
      result = "多选题";
      break;
    case "nps":
      result = "NPS";
      break;
    case "select":
      result = "下拉框";
      break;
    case "fen":
      result = "评分题";
      break;
  }
  return result;
};

/**
 * 验证密码
 * 长度为8-18位字符，不能包括空格，必须包含字母、数字、符号中至少2种
 * @param {*} value 输入的值
 */
export const passwordValidation = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入密码"));
  } else {
    if (!/^(?![A-Za-z]*$)(?![0-9]*$)(?![^A-Za-z0-9]*$)\S{8,18}$/.test(value)) {
      callback(
        new Error(
          "长度为8-18位字符，不能包括空格，必须包含字母、数字、符号中至少2种"
        )
      );
    } else {
    }
    callback();
  }
};

export const cutNameLength = name => {
  if (!name) return;
  name = name.replace(/(^\s*)|(\s*$)/g, "");
  let reg = /^[\u2E80-\u9FFF]+$/; // Unicode编码中的汉字范围
  if (reg.test(name)) {
    return name.substring(
      name.length - 2 < 0 ? 0 : name.length - 2,
      name.length
    );
  } else {
    return name.substring(
      name.length - 4 < 0 ? 0 : name.length - 4,
      name.length
    );
  }
};

export const activityStatus = value => {
  let tempstr = value;
  switch (value) {
    case 0:
      tempstr = "暂存";
      break;
    case 1:
      tempstr = "已审核";
      break;
    case 2:
      tempstr = "待审核";
      break;
    case 3:
      tempstr = "被驳回";
      break;
  }
  return tempstr;
};


// 邮件发送状态
export const emailFailedType = value => {
  let tempstr = value;
  switch (value) {
    case "SendOk":
      tempstr = "投递成功";
      break;
    case "SysOutDnsResolveFail":
      tempstr = "收信账户DNS解析失败，一般是无效域名。从您收信列表剔除";
      break;
    case "SmtpMfFreq":
      tempstr = "发信账户被流控。降低您的发信频率";
      break;
    case "SmtpContSpam":
      tempstr = "内容被对方判断为垃圾邮件。完善您的发信内容";
      break;
    case "SmtpAuthFail":
      tempstr = "SPF或者DKIM校验失败。请解析正确的SPF，并且测试下DKIM是否正确";
      break;
    case "SmtpNxBox":
      tempstr = "无效地址。从您收信列表剔除";
      break;
    case "SysOutInvRcpt":
      tempstr = "无效地址。从您收信列表剔除";
      break;
    case "SmtpRcptFreq":
      tempstr = "收信系统疲劳度控制。请暂时停止给当前收信人发信";
      break;
    case "SmtpTempErr":
      tempstr = "临时错误。请重试。";
      break;
    case "SmtpZPermErr":
      tempstr = "永久错误。请不要重试，根据对方返回信息确认具体的错误原因。";
      break;
  }
  return tempstr;
};
export const sourceType = (source) => {
  let sourceName = "";
  switch (source) {
    case "1":
      sourceName = "直播生成视频";
      break;
    case "2":
      sourceName = "自传直播视频";
      break;
    case "3":
      sourceName = "直播视频上传中";
      break;
    case "9":
      sourceName = "自传网站视频";
      break;
    default:
      break;
  }
  return sourceName;
};

export const fileSize = (limit) => {
  let size = "";
  if (limit && limit != 0) {
    if (limit < 0.1 * 1024) {
      //小于0.1KB，则转化成B
      size = limit.toFixed(2) + "B";
    } else if (limit < 0.1 * 1024 * 1024) {
      //小于0.1MB，则转化成KB
      size = (limit / 1024).toFixed(2) + "KB";
    } else if (limit < 0.1 * 1024 * 1024 * 1024) {
      //小于0.1GB，则转化成MB
      size = (limit / (1024 * 1024)).toFixed(2) + "MB";
    } else {
      //其他转化成GB
      size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }
    let sizeStr = size + ""; //转成字符串
    let index = sizeStr.indexOf("."); //获取小数点处的索引
    let dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
    if (dou == "00") {
      //判断后两位是否为00，如果是则删除00
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
  }
  return size;
};
/**
 * 类型分总
 */
export const fileType = (type) => {
  let result = "其他";
  switch (type) {
    case "cda":
    case "wav":
    case "mp3":
    case "ra":
    case "midi":
    case "ogg":
    case "ape":
    case "flac":
    case "aac":
      result = "音频";
      break;
    case "rm":
    case "rmvb":
    case "mpeg1-4":
    case "mov":
    case "mtv":
    case "dat":
    case "wmv":
    case "avi":
    case "3gp":
    case "amv":
    case "dmv":
    case "flv":
    case "mp4":
      result = "视频";
      break;
    case "bmp":
    case "jpg":
    case "png":
    case "tif":
    case "gif":
    case "pcx":
    case "exif":
    case "fpx":
    case "svg":
    case "psd":
    case "cdr":
    case "pcd":
    case "dxf":
    case "ufo":
    case "eps":
    case "ai":
    case "raw":
    case "WMF":
    case "webp":
      result = "图片";
      break;
    case "rar":
    case "zip":
      result = "压缩文件";
      break;
    case "pdf":
      result = "PDF";
      break;
    case "doc":
    case "docx":
      result = "doc";
      break;
    case "xlsx":
    case "xls":
      result = "excel";
      break;
    case "ppt":
    case "pptx":
      result = "ppt";
      break;
  }
  return result;
};